import { render } from "./ShipmentPackageBatchDateContent.vue?vue&type=template&id=23bda90a&scoped=true"
import script from "./ShipmentPackageBatchDateContent.vue?vue&type=script&lang=js"
export * from "./ShipmentPackageBatchDateContent.vue?vue&type=script&lang=js"

import "./ShipmentPackageBatchDateContent.vue?vue&type=style&index=0&id=23bda90a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bda90a"]])

export default __exports__